import { useState, useEffect } from "react";

import Cookies from 'universal-cookie';

import { GetListPag, RegisterListPag, SetListPag } from "interface/Page";

import MesaUnimil from "components/MesaUnimil";
import MesaPartsAndServices from "components/MesaPartsAndServices";
import MesaUpgrades from "components/MesaUpgrades";
import MesaOperationCenter from "components/MesaOperationCenter";

export default function App() {

    const cookies = new Cookies();

    const nameUrl                         = window.location.href.split("#");
    const [ currentPage, setCurrentPage ] = useState(GetListPag('currentPage'));

    useEffect(()=>{
        RegisterListPag('currentPage', setCurrentPage);
    }, []);

    useEffect(()=>{
        setCurrentPage(GetListPag('currentPage'));
    }, [currentPage]);

    useEffect(()=>{
        switch (nameUrl[1]) {
            case 'operationscenter': case 'unimil': case 'partsandservices': case 'upgrades':
                    PageClick(nameUrl[1]);
                break;
        }
        setCurrentPage(GetListPag('currentPage'));
    }, [nameUrl]);

    function PageClick(value){
        SetListPag('currentPage', value);
    }
    
    let countClick = 0;
    function ResetPage(value){
        countClick = countClick + 1;
        if(countClick == 3){
            window.location.reload(true);
        }
    }

    function CurrentPageData(){
        switch (currentPage) {
            case 'index':
                return(
                    <div className="list_table">
                        <div className="table" onClick={ ()=>{ PageClick('operationscenter') } }>
                            Operation center
                        </div>
                        <div className="table" onClick={ ()=>{ PageClick('unimil') } }>
                            Unimil
                        </div>
                        <div className="table" onClick={ ()=>{ PageClick('partsandservices') } }>
                            Peças e serviços
                        </div>
                        <div className="table" onClick={ ()=>{ PageClick('upgrades') } }>
                            Upgrades
                        </div>
                    </div>
                );

            case "operationscenter":
                return <MesaOperationCenter PageClick={ PageClick } ResetPage={ ResetPage } />;

            case "upgrades":
                return <MesaUpgrades PageClick={ PageClick } ResetPage={ ResetPage } />;

            case "unimil":
                return <MesaUnimil PageClick={ PageClick } ResetPage={ ResetPage } />;

            case "partsandservices":
                return <MesaPartsAndServices PageClick={ PageClick } ResetPage={ ResetPage } />;
        }
    } 

    return CurrentPageData();
}